import { AccountPreferencesView, AccountPreferenceView } from '@zola/svc-marketplace-ts-types';

import ApiService from '~/util/apiService';

export const fetchFirstMovePreferences = async (keys: AccountPreferenceView.KeyEnum[]) => {
  return ApiService.get<AccountPreferencesView>('/web-marketplace-api/v1/account-preferences').then(
    (accountPreferences) => {
      const mappedPreferences: Record<AccountPreferenceView.KeyEnum, AccountPreferenceView | null> =
        {
          FIRST_MOVES_SHARE_FAVORITES: null,
          FIRST_MOVES_SHARE_INQUIRIES: null,
          FIRST_MOVES_SHARE_WEDDING_DETAILS: null,
        };

      keys.map((key) => {
        const preference = (accountPreferences.accountPreferences || []).find(
          (pref) => pref.key === key
        );
        if (preference) {
          mappedPreferences[key] = preference;
        }
      });

      return mappedPreferences;
    }
  );
};
